import { useEffect, useState } from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_sales-pipeline-hub-24/artifacts/mmegsjtv_Ameenji.logo%20Black%20.png";

export default function SplashScreen({ onFinish }) {
  const [phase, setPhase] = useState("enter"); // enter → hold → exit

  useEffect(() => {
    const t1 = setTimeout(() => setPhase("hold"), 120);
    const t2 = setTimeout(() => setPhase("exit"), 2100);
    const t3 = setTimeout(() => onFinish(), 2700);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [onFinish]);

  return (
    <div
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center transition-opacity duration-[600ms] ease-[cubic-bezier(0.16,1,0.3,1)] ${
        phase === "exit" ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
      style={{
        background:
          "radial-gradient(120% 80% at 50% 30%, #ffffff 0%, #f8fafc 55%, #eef3f4 100%)",
      }}
      data-testid="splash-screen"
    >
      {/* soft gold halo behind logo */}
      <div
        aria-hidden
        className={`absolute h-72 w-72 rounded-full bg-[#FBBA00]/15 blur-3xl transition-all duration-1000 ease-[cubic-bezier(0.16,1,0.3,1)] ${
          phase === "enter" ? "opacity-0 scale-90" : phase === "exit" ? "opacity-0 scale-110" : "opacity-100 scale-100"
        }`}
      />
      <div
        aria-hidden
        className={`absolute h-60 w-60 rounded-full bg-[#155155]/10 blur-3xl transition-all duration-1000 ease-[cubic-bezier(0.16,1,0.3,1)] delay-100 ${
          phase === "enter" ? "opacity-0" : phase === "exit" ? "opacity-0" : "opacity-100"
        }`}
        style={{ transform: "translateY(20px)" }}
      />

      {/* Logo with subtle rise + scale */}
      <img
        src={LOGO_URL}
        alt="Ameenji"
        className={`relative w-48 sm:w-56 transition-all duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)] ${
          phase === "enter" ? "opacity-0 scale-[0.92] translate-y-3" : "opacity-100 scale-100 translate-y-0"
        }`}
        draggable={false}
      />

      {/* Tagline */}
      <p
        className={`relative mt-2 text-[10px] sm:text-xs tracking-[0.4em] uppercase text-slate-500 font-medium transition-all duration-700 delay-200 ${
          phase === "enter" ? "opacity-0 translate-y-2" : phase === "exit" ? "opacity-0" : "opacity-100 translate-y-0"
        }`}
      >
        Excellence · Endurance
      </p>

      {/* Loading dots */}
      <div
        className={`relative mt-10 flex items-center gap-1.5 transition-all duration-500 delay-500 ${
          phase === "enter" ? "opacity-0" : phase === "exit" ? "opacity-0" : "opacity-100"
        }`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-[#155155] animate-bounce" style={{ animationDelay: "0ms" }} />
        <span className="h-1.5 w-1.5 rounded-full bg-[#FBBA00] animate-bounce" style={{ animationDelay: "150ms" }} />
        <span className="h-1.5 w-1.5 rounded-full bg-[#155155] animate-bounce" style={{ animationDelay: "300ms" }} />
      </div>
    </div>
  );
}
